import controller from './sign-in.controller';
import template from './sign-in.pug';

const SignInComponent = {
  template,
  controller,
};

export default SignInComponent;



// WEBPACK FOOTER //
// ./client/app/oauth/sign-in/sign-in.component.js